<template>
  <div class="">
    <div id="certify">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in bannerArr" :key="item.pic + index">
            <img class="icon1" :src="item.pic" />
          </div>
        </div>
        <!-- 如果你需要分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>

        <!-- 如果你需要导航按钮 -->
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
      </div>

    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  name: "swiper",
  data () {
    return {
      bannerArr: []
    }
  },
  created () {

  },
  mounted () {

    this.$axios.get('/erp/website_banner/list', '')
      .then((res) => {
        if (res.code == 0) {
          this.bannerArr = res.data.data
          this.$nextTick(function () {  //l轮播图初始化函数carouselScroll一定要放在$nextTick回调中执行
            this.carouselScroll();
          })

        } else {

        }
      })
  },
  methods: {
    carouselScroll () {
      new Swiper("#certify .swiper-container", {
        watchSlidesProgress: true,
        slidesPerView: 1,
        centeredSlides: true,
        // loop: true,
        // loopedSlides: 1,
        autoplay: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination"
          //clickable :true,
        },
        autoplay: {
          disableOnInteraction: false,  // 用户操作swiper之后，是否禁止autoplay （没有加入之前轮播图设置 autoplay：true无效）
          delay: 2000, // 自动切换的时间间隔（单位ms）
        },
        observeParents: false,   //必须加入
        observer: true, //必须加入
      })
    }
  }
};
</script>

<style lang="" scoped>
.title1 {
  font-size: 24px;
  color: #333;
  margin: 35px auto 30px;
}
.title2 {
  font-size: 16px;
  color: #333;
  line-height: 26px;
}
#certify {
  position: relative;
  width: 100%;
  margin: 0 auto;
}
#certify .swiper-container {
  /* padding-bottom: 60px; */
  margin: 0px auto 0px;
}

#certify .swiper-slide {
  width: 100%;
  height: 100%;
}
#certify .swiper-slide img {
  display: block;
  width: 100%;
  height: auto;
}
#certify .swiper-slide p {
  text-align: center;
}

#certify .swiper-pagination {
  width: 100%;
  bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/swiper.vue